import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Button,
  Form,
  Input,
  Divider,
  ButtonGroup,
  Icon,
} from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  StyledButton,
  StyledForm,
  StyledDropdown,
  ExcludeButtonContainer,
  CreatedInscritoContainer,
  LineContainer,
  StyledLabel,
  StyledLineContent,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

const CriarInscricoesEventos = (props) => {
  const [inscritosEventos, setInscritosEventos] = useState([
    {
      nome: "",
      email: "",
      preToken: "",
      parceiro: 0,
      id_evento: 1,
      codigo_cupom: "",
    },
  ]);

  const [createdInscritosEventos, setCreatedInscritosEventos] = useState([]);

  const [opcoesEventos, setOpcoesEventos] = useState([]);

  const parceirosOptions = {
    0: "Não parceiro (aluno)",
    1: "Embaixador",
    2: "EJ",
  };

  const handleInscritosEventos = useCallback(
    (value, key, index) => {
      const newInscritosEventos = [...inscritosEventos];

      newInscritosEventos[index][key] = value;

      setInscritosEventos(newInscritosEventos);
    },
    [inscritosEventos]
  );

  const handleRemove = useCallback(
    (index) => {
      const newInscritosEventos = [...inscritosEventos];

      newInscritosEventos.splice(index, 1);

      setInscritosEventos(newInscritosEventos);
    },
    [inscritosEventos]
  );

  const verifyInscrito = (inscrito) => {
    const isValid = Object.keys(inscrito)
      .filter(
        (key) =>
          !["parceiro", "id_evento", "preToken", "codigo_cupom"].includes(key)
      )
      .every((key) => !!inscrito[key]);

    return isValid;
  };

  const handleAdd = useCallback(() => {
    const newInscritosEventos = [...inscritosEventos];

    newInscritosEventos.push({
      nome: "",
      email: "",
      preToken: "",
      parceiro: 0,
      id_evento: 1,
      codigo_cupom: "",
    });

    setInscritosEventos(newInscritosEventos);
  }, [inscritosEventos]);

  const handleSave = useCallback(async () => {
    try {
      const allValid = inscritosEventos.every((inscritoEvento) =>
        verifyInscrito(inscritoEvento)
      );

      if (!allValid) {
        swal("Erro !", "Preencha todos os campos", "error");
      }

      const payload = {
        dados: inscritosEventos,
      };

      const createdResponse = await api.post(
        "/admin/inscricoes-eventos/multi-cadastro",
        payload
      );

      const response = await Promise.all(
        createdResponse.data.map(async (createdInscrito) => {
          const params = {
            id_inscricao: createdInscrito.id,
          };

          const profile =
            (await api.get("inscricoes-eventos/subscriptions", { params }))
              ?.data?.profile || null;

          return profile;
        })
      );

      setCreatedInscritosEventos(response);
    } catch (err) {
      console.error(err);

      const mensagem =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Erro ao cadastrar alunos/parceiros";
      swal("Erro !", mensagem, "error");
    }
  }, [inscritosEventos]);

  const handleClean = useCallback(() => {
    setInscritosEventos([
      {
        nome: "",
        email: "",
        preToken: "",
        parceiro: 0,
        id_evento: 1,
        codigo_cupom: "",
      },
    ]);
    setCreatedInscritosEventos([]);
  }, []);

  useEffect(() => {
    api.get("eventos").then((res) => {
      const newEventos = res.data.map((evento) => ({
        key: evento.id,
        text: evento.titulo,
        value: evento.id,
      }));

      setOpcoesEventos(newEventos);
    });
  }, []);

  if (createdInscritosEventos.length) {
    return (
      <div style={{ width: "100vw", paddingLeft: "250px" }}>
        <Container>
          <AdminMenu />
          <Content>
            <Title>Participante(s) Recem Registrados</Title>

            {createdInscritosEventos.map((createdInscritosEvento, index) => (
              <CreatedInscritoContainer>
                <LineContainer>
                  <StyledLabel>Nome:</StyledLabel>
                  <StyledLineContent>
                    {createdInscritosEvento.nome}
                  </StyledLineContent>
                </LineContainer>
                <LineContainer>
                  <StyledLabel>Email:</StyledLabel>
                  <StyledLineContent>
                    {createdInscritosEvento.email}
                  </StyledLineContent>
                </LineContainer>
                <LineContainer>
                  <StyledLabel>Token:</StyledLabel>
                  <StyledLineContent>
                    {createdInscritosEvento.id}
                  </StyledLineContent>
                </LineContainer>
                <LineContainer>
                  <StyledLabel>Link de Compartilhamento:</StyledLabel>
                  <StyledLineContent>
                    {createdInscritosEvento?.evento?.id === 15 ||
                    createdInscritosEvento?.evento?.id === 16 ? (
                      <a
                        href={`https://voitto.com.br/evento/${createdInscritosEvento?.evento?.url_evento}?token=${createdInscritosEvento.id}`}
                      >
                        {`https://voitto.com.br/evento/${createdInscritosEvento?.evento?.url_evento}?token=${createdInscritosEvento.id}`}
                      </a>
                    ) : (
                      <a
                        href={`https://voitto.com.br/${createdInscritosEvento?.evento?.url_evento}?token=${createdInscritosEvento.id}`}
                      >
                        {`https://voitto.com.br/${createdInscritosEvento?.evento?.url_evento}?token=${createdInscritosEvento.id}`}
                      </a>
                    )}
                  </StyledLineContent>
                </LineContainer>
                <LineContainer>
                  <StyledLabel>Link de Acompanhamento:</StyledLabel>
                  <StyledLineContent>
                    {createdInscritosEvento?.evento?.id === 15 ||
                    createdInscritosEvento?.evento?.id === 16 ? (
                      <a
                        href={`https://voitto.com.br/evento/${createdInscritosEvento?.evento?.url_evento}/agradecimento?token=${createdInscritosEvento.id}`}
                      >
                        {`https://voitto.com.br/evento/${createdInscritosEvento?.evento?.url_evento}/agradecimento?token=${createdInscritosEvento.id}`}
                      </a>
                    ) : (
                      <a
                        href={`https://voitto.com.br/${createdInscritosEvento?.evento?.url_evento}/agradecimento?token=${createdInscritosEvento.id}`}
                      >
                        {`https://voitto.com.br/${createdInscritosEvento?.evento?.url_evento}/agradecimento?token=${createdInscritosEvento.id}`}
                      </a>
                    )}
                  </StyledLineContent>
                </LineContainer>
              </CreatedInscritoContainer>
            ))}

            <ButtonGroup>
              <StyledButton color="blue" onClick={handleClean}>
                Criar mais participantes
              </StyledButton>
            </ButtonGroup>
          </Content>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Adicionar Participante(s)</Title>

          {inscritosEventos.map((inscritosEvento, index) => (
            <StyledForm>
              <ExcludeButtonContainer onClick={() => handleRemove(index)}>
                <Icon name="close icon" />
              </ExcludeButtonContainer>
              <Form.Field
                control={Input}
                label="Nome"
                placeholder="Nome"
                value={inscritosEvento.nome}
                onChange={(e) =>
                  handleInscritosEventos(e.target.value, "nome", index)
                }
              />
              <Form.Field
                control={Input}
                label="Email"
                placeholder="Email"
                value={inscritosEvento.email}
                onChange={(e) =>
                  handleInscritosEventos(e.target.value, "email", index)
                }
              />
              <Form.Field
                control={Input}
                label="Pre-Token"
                placeholder="Pre-Token"
                value={inscritosEvento.preToken}
                onChange={(e) =>
                  handleInscritosEventos(e.target.value, "preToken", index)
                }
              />
              <Form.Field
                control={Input}
                label="Cupom personalizado (opcional)"
                placeholder="Ex: PARCERIAXTUDO90 (vazio = cupom padrão da landing)"
                value={inscritosEvento.codigo_cupom}
                onChange={(e) =>
                  handleInscritosEventos(
                    e.target.value,
                    "codigo_cupom",
                    index
                  )
                }
              />
              <Form.Field>
                <Label>Evento</Label>
                <StyledDropdown
                  fluid
                  selection
                  options={opcoesEventos}
                  onChange={(e, { value }) =>
                    handleInscritosEventos(value, "id_evento", index)
                  }
                  value={inscritosEvento.id_evento}
                />
              </Form.Field>
            </StyledForm>
          ))}

          <ButtonGroup>
            <StyledButton color="blue" onClick={handleAdd}>
              Adicionar Participante
            </StyledButton>
            <StyledButton color="green" onClick={handleSave}>
              Salvar
            </StyledButton>
          </ButtonGroup>
        </Content>
      </Container>
    </div>
  );
};

export default withRouter(CriarInscricoesEventos);
